/**
 * Component Alignement
 */
export var Alignable;
(function (Alignable) {
    Alignable["ALIGNED_CENTER"] = "ALIGNED_CENTER";
    Alignable["ALIGNED_START"] = "ALIGNED_START";
    Alignable["ALIGNED_END"] = "ALIGNED_END";
    Alignable["ALIGNED_STRETCH"] = "ALIGNED_STRETCH";
})(Alignable || (Alignable = {}));
export var Align;
(function (Align) {
    Align["CENTER"] = "CENTER";
    Align["START"] = "START";
    Align["END"] = "END";
    Align["STRETCH"] = "STRETCH";
})(Align || (Align = {}));
/**
 * Returns alignement classname depending on align type
 * @param alignType {Alignable|string} - Alert type
 * @returns {string} - Align value
 */
export var getAlignClassName = function (alignType) {
    switch (alignType) {
        case 'ALIGNED_CENTER':
            return 'aligned-center';
        case 'CENTER':
            return 'aligned-center';
        case 'ALIGNED_START':
            return 'aligned-start';
        case 'START':
            return 'aligned-start';
        case 'ALIGNED_END':
            return 'aligned-end';
        case 'END':
            return 'aligned-end';
        case 'STRETCH':
            return 'aligned-stretch';
        default:
            return 'aligned-start';
    }
};
/**
 * Returns alignement classname depending on align type
 * @param alignType {Alignable|string} - Align type
 * @returns {string} - Align value
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export var getAlignStyle = function (alignType) {
    switch (alignType) {
        case 'ALIGNED_CENTER':
            return 'center';
        case 'ALIGNED_START':
            return 'flex-start';
        case 'ALIGNED_END':
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxpZ25hYmxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vb2JqZWN0cy9mYWNldHMvQWxpZ25hYmxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksU0FLWDtBQUxELFdBQVksU0FBUztJQUNuQiw4Q0FBaUMsQ0FBQTtJQUNqQyw0Q0FBK0IsQ0FBQTtJQUMvQix3Q0FBMkIsQ0FBQTtJQUMzQixnREFBbUMsQ0FBQTtBQUNyQyxDQUFDLEVBTFcsU0FBUyxLQUFULFNBQVMsUUFLcEI7QUFFRCxNQUFNLENBQU4sSUFBWSxLQUtYO0FBTEQsV0FBWSxLQUFLO0lBQ2YsMEJBQWlCLENBQUE7SUFDakIsd0JBQWUsQ0FBQTtJQUNmLG9CQUFXLENBQUE7SUFDWCw0QkFBbUIsQ0FBQTtBQUNyQixDQUFDLEVBTFcsS0FBSyxLQUFMLEtBQUssUUFLaEI7QUFTRDs7OztHQUlHO0FBQ0gsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQUcsVUFBQyxTQUFrQjtJQUNsRCxRQUFRLFNBQVMsRUFBRTtRQUNqQixLQUFLLGdCQUFnQjtZQUNuQixPQUFPLGdCQUFnQixDQUFBO1FBQ3pCLEtBQUssUUFBUTtZQUNYLE9BQU8sZ0JBQWdCLENBQUE7UUFDekIsS0FBSyxlQUFlO1lBQ2xCLE9BQU8sZUFBZSxDQUFBO1FBQ3hCLEtBQUssT0FBTztZQUNWLE9BQU8sZUFBZSxDQUFBO1FBQ3hCLEtBQUssYUFBYTtZQUNoQixPQUFPLGFBQWEsQ0FBQTtRQUN0QixLQUFLLEtBQUs7WUFDUixPQUFPLGFBQWEsQ0FBQTtRQUN0QixLQUFLLFNBQVM7WUFDWixPQUFPLGlCQUFpQixDQUFBO1FBQzFCO1lBQ0UsT0FBTyxlQUFlLENBQUE7S0FDekI7QUFDSCxDQUFDLENBQUE7QUFFRDs7OztHQUlHO0FBQ0gsNkVBQTZFO0FBQzdFLE1BQU0sQ0FBQyxJQUFNLGFBQWEsR0FBRyxVQUFDLFNBQWtCO0lBQzlDLFFBQVEsU0FBUyxFQUFFO1FBQ2pCLEtBQUssZ0JBQWdCO1lBQ25CLE9BQU8sUUFBUSxDQUFBO1FBQ2pCLEtBQUssZUFBZTtZQUNsQixPQUFPLFlBQVksQ0FBQTtRQUNyQixLQUFLLGFBQWE7WUFDaEIsT0FBTyxVQUFVLENBQUE7UUFDbkI7WUFDRSxPQUFPLFlBQVksQ0FBQTtLQUN0QjtBQUNILENBQUMsQ0FBQSJ9